export default "__VITE_ASSET__BrpGXaS2__"